module.exports = __webpack_public_path__ + "audio/oneAudio.4f4f0bcf.mp3";